import { NavLink, Outlet } from "react-router-dom";
import {
  LayoutDashboard,
  CalendarDays,
  CalendarRange,
  Users,
  UserCog,
  Clock3,
  PartyPopper,
  Share2,
  LogOut,
} from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/app/calendario", label: "Calendario", icon: CalendarRange },
  { to: "/app/agenda", label: "Agenda", icon: CalendarDays },
  { to: "/app/clientes", label: "Clientes", icon: Users },
  { to: "/app/terapeutas", label: "Terapeutas", icon: UserCog },
  { to: "/app/panel", label: "Panel", icon: LayoutDashboard },
  { to: "/app/disponibilidad", label: "Disponibilidad", icon: Clock3 },
  { to: "/app/efemerides", label: "Efemérides", icon: PartyPopper },
  { to: "/app/afiliados", label: "Afiliados", icon: Share2 },
];

export const DashboardLayout = () => {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex warm-canvas">
      <aside className="hidden md:flex w-64 flex-col border-r border-slate-200 bg-white shrink-0">
        <div className="px-5 py-5 border-b border-slate-100">
          <Logo />
        </div>

        <nav className="flex-1 p-3 space-y-1">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                  isActive ? "text-white" : "text-slate-600 hover:bg-slate-100"
                }`
              }
              style={({ isActive }) => (isActive ? { backgroundColor: "#275FBE" } : {})}
            >
              <item.icon className="h-4.5 w-4.5" />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-slate-100 space-y-2">
          <div className="px-2 text-xs text-slate-400 truncate">{user?.email}</div>
          <button
            onClick={logout}
            data-testid="logout-button"
            className="w-full flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-medium text-slate-600 hover:bg-slate-100 transition-colors"
          >
            <LogOut className="h-4 w-4" /> Cerrar sesión
          </button>
        </div>
      </aside>

      <div className="flex-1 flex flex-col min-w-0">
        {/* Nav superior para móvil */}
        <div className="md:hidden flex gap-1 overflow-x-auto border-b border-slate-200 bg-white px-3 py-2">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap ${
                  isActive ? "text-white" : "text-slate-600 bg-slate-100"
                }`
              }
              style={({ isActive }) => (isActive ? { backgroundColor: "#275FBE" } : {})}
            >
              <item.icon className="h-3.5 w-3.5" />
              {item.label}
            </NavLink>
          ))}
        </div>

        <main className="flex-1 px-5 sm:px-8 py-8 max-w-5xl w-full mx-auto">
          <Outlet />
        </main>
        <footer className="border-t border-slate-200 py-4 text-center text-xs text-slate-500">
          Agenda Terapias · Tu trabajo, más claro y sin olvidos.
        </footer>
      </div>
    </div>
  );
};
